import imageCompression from "browser-image-compression";
import i18next from "i18next";

export const MessageTypes = Object.freeze({
  ANNOUNCEMENT: "Announcement",
  REQUEST: "Request",
});

const DEFAULT_PASS_MIN_LENGTH = 6;
const MAX_ID_LENGTH = 16;

const MAX_PRICE_LENGTH = 15;
const MAX_AMOUNT_LENGTH = 15;
const MAX_NAME_LENGTH = 200;
const MAX_DETAIL_LENGTH = 300;
const MAX_LARGEDETAIL_LENGTH = 2000;
const MAX_SETTYPE_LENGTH = 30;

const MAX_PASSWORD_LENGTH = 100;

const MAX_LENGTHS = {
  id: MAX_ID_LENGTH,
  price: MAX_PRICE_LENGTH,
  amount: MAX_AMOUNT_LENGTH,
  name: MAX_NAME_LENGTH,
  detail: MAX_DETAIL_LENGTH,
  largeDetail: MAX_LARGEDETAIL_LENGTH,
  setType: MAX_SETTYPE_LENGTH,
};

// ID patterns for validation
const idPatterns = {
  MSG: /^MSG-[A-Z]{5}-[A-Z]{3}$/,
};

export function getFilterOutNaNs(array) {
  return array.filter((item) => {
    return !isNaN(item);
  });
}

export function GetLink() {
  if (process.env.REACT_APP_ENV === "test") {
    return "http://localhost:4000/api";
  } else {
    return "https://ustorage.umanage.rs/api";
  }
}

export function GetStorageLink() {
  if (process.env.REACT_APP_ENV === "test") {
    return "http://localhost:4000/api/images/";
  } else {
    return "https://ustorage.umanage.rs/api/images/";
  }
}

export function getErrorMsgAndCode(error) {
  let err;
  let errCode;
  let translationParams = {};
  console.log(
    "GETERRORANDMSGCODEGetting error msg and code for",
    error.response
  );
  if (error.response) {
    const errorData = error.response.data?.errorKey;
    errCode = error.response.status;

    if (typeof errorData === "string") {
      translationParams = error.response.data?.params || {};
      console.log("GETERRORANDMSGCODEerror with code res1", translationParams);
      err = i18next.t(errorData, { ns: "backend", ...translationParams });
    } else if (typeof errorData === "object") {
      translationParams = errorData.params || {};
      console.log("GETERRORANDMSGCODEerror with code res2", translationParams);
      err = i18next.t(errorData.err, { ns: "backend", ...translationParams });
    } else {
      console.log(
        "GETERRORANDMSGCODEerror with code res3",
        errorData,
        translationParams
      );
      err =
        errorData || i18next.t("error:server.unknownError", { ns: "backend" });
    }
  } else {
    err =
      error.message ||
      i18next.t("error:server.connectionFailed", { ns: "backend" });
    errCode = 500;
  }
  console.log("GETERRORANDMSGCODEerror with code res4", translationParams);
  return { err: err, errCode: errCode, params: translationParams };
}

export async function compressImage(image) {
  try {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      fileType: "image/jpeg",
      initialQuality: 0.8,
    };

    const compressedFile = await imageCompression(image, options);

    if (compressedFile.size > 2 * 1024 * 1024) {
      throw new Error(i18next.t("error:compression.tooLarge"));
    }
    return compressedFile;
  } catch (error) {
    console.error("Compression failed:", error);
    throw new Error(i18next.t("error:compression.failed"));
  }
}

export function validateInput(Parms) {
  let obj = { err: "", errCode: 0 };

  Parms.forEach((parm) => {
    if (!parm.MinLength && parm.MinLength !== 0) {
      if (parm.Type === "password") parm.MinLength = DEFAULT_PASS_MIN_LENGTH;
      else {
        parm.MinLength = 0;
      }
    }

    if (!parm.MaxLengthType) {
      parm.MaxLengthType = "detail";
    }
    if (parm.Value?.toString().length === 0 && parm.MinLength === 0) return obj;
    if (
      (!parm.Value?.toString().length && parm.MinLength > 0) ||
      (parm.Value?.toString().length &&
        parm.Value?.toString().length < parm.MinLength)
    ) {
      if (
        parm.Type === "string" ||
        parm.Type === "int" ||
        parm.Type === "float"
      ) {
        obj = {
          err: i18next.t("error:validation.minLength", {
            field: i18next.t(parm.Name),
            length: parm.MinLength,
          }),
          errCode: 400,
        };
      }
    }

    if (
      parm.Value?.toString().length &&
      parm.Value?.toString().length > MAX_LENGTHS[parm.MaxLengthType]
    ) {
      if (
        parm.Type === "string" ||
        parm.Type === "int" ||
        parm.Type === "float"
      ) {
        obj = {
          err: i18next.t("error:validation.maxLength", {
            field: i18next.t(parm.Name),
            length: MAX_LENGTHS[parm.MaxLengthType],
          }),
          errCode: 400,
        };
      }
    }

    if (!parm.OnlyCheckLength) {
      switch (parm.Type) {
        case "int":
          if (
            (!parm.Value && (parm.Value !== 0 || !parm.AllowZero)) ||
            !/^\d+$/.test(parm.Value)
          ) {
            obj = {
              err:
                parm.Message === undefined
                  ? i18next.t("error:validation.emptyDigitsOnly", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          }
          break;

        case "float":
          if (
            (!parm.Value && (parm.Value !== 0 || !parm.AllowZero)) ||
            !/^\d+(\.\d+)?$/.test(parm.Value)
          ) {
            obj = {
              err:
                parm.Message === undefined
                  ? i18next.t("error:validation.emptyDigitsDecimal", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          }
          break;

        case "string":
          if (!parm.Value || !/\S/.test(parm.Value)) {
            obj = {
              err:
                parm.Message == undefined
                  ? i18next.t("error:validation.empty", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          } else if (
            parm.MinLength !== undefined &&
            parm.Value.length < parm.MinLength
          ) {
            obj = {
              err: i18next.t("error:validation.minLength", {
                field: i18next.t(parm.Name),
                length: parm.MinLength,
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "username":
          console.log(
            parm,
            "username case",
            !parm.Value,
            !/\S/.test(parm.Value),
            /@/.test(parm.Value),
            /^\d+$/.test(parm.Value),
            parm.MinLength !== undefined,
            parm.Value.length < parm.MinLength,
            parm.Value.length > MAX_NAME_LENGTH
          );
          if (!parm.Value || !/\S/.test(parm.Value)) {
            obj = {
              err:
                parm.Message == undefined
                  ? i18next.t("error:validation.empty", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          } else if (/@/.test(parm.Value) || /^\d+$/.test(parm.Value)) {
            obj = {
              err: i18next.t("error:validation.usernameFormat", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          } else if (
            parm.MinLength !== undefined &&
            parm.Value.length < parm.MinLength
          ) {
            obj = {
              err: i18next.t("error:validation.minLength", {
                field: i18next.t(parm.Name),
                length: parm.MinLength,
              }),
              errCode: 400,
            };
            return;
          } else if (parm.Value.length > MAX_NAME_LENGTH) {
            obj = {
              err: i18next.t("error:validation.maxLength", {
                field: i18next.t(parm.Name),
                length: MAX_NAME_LENGTH,
              }),
              errCode: 400,
            };
            return;
          }
          console.log("username case good");
          break;

        case "password":
          if (!parm.Value || !/\S/.test(parm.Value)) {
            obj = {
              err:
                parm.Message == undefined
                  ? i18next.t("error:validation.empty", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          } else if (
            parm.MinLength !== undefined &&
            parm.Value.length < parm.MinLength
          ) {
            obj = {
              err: i18next.t("error:validation.minLength", {
                field: i18next.t(parm.Name),
                length: parm.MinLength,
              }),
              errCode: 400,
            };
            return;
          } else if (
            !/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+[\]{}|;:'",.<>?/\\-])/.test(
              parm.Value
            )
          ) {
            obj = {
              err: i18next.t("error:validation.passwordRequirements", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          } else if (parm.Value.length > MAX_PASSWORD_LENGTH) {
            obj = {
              err: i18next.t("error:validation.maxLength", {
                field: i18next.t(parm.Name),
                length: MAX_PASSWORD_LENGTH,
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "passwordLogin":
          if (!parm.Value || !/\S/.test(parm.Value)) {
            obj = {
              err:
                parm.Message == undefined
                  ? i18next.t("error:validation.empty", {
                      field: i18next.t(parm.Name),
                    })
                  : parm.Message,
              errCode: 400,
            };
            return;
          } else if (
            parm.MinLength !== undefined &&
            parm.Value.length < parm.MinLength
          ) {
            obj = {
              err: i18next.t("error:validation.minLength", {
                field: i18next.t(parm.Name),
                length: parm.MinLength,
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "email":
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(parm.Value)) {
            obj = {
              err: i18next.t("error:validation.emailFormat"),
              errCode: 400,
            };
            return;
          } else if (parm.Value.length > MAX_NAME_LENGTH) {
            obj = {
              err: i18next.t("error:validation.maxLength", {
                field: i18next.t(parm.Name),
                length: MAX_NAME_LENGTH,
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "array":
          if (!Array.isArray(parm.Value) || parm.Value.length === 0) {
            console.log(
              "Info for array error",
              parm.Value,
              Array.isArray(parm.Value),
              parm.Value.length === 0
            );
            obj = {
              err: i18next.t("error:validation.arrayEmpty", {
                field: i18next.t(parm.Name).toLowerCase(),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "id":
          if (!parm.Value || typeof parm.Value !== "string") {
            obj = {
              err: i18next.t("error:validation.empty", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          const prefix = parm.Value.split("-")[0];
          const pattern = idPatterns[prefix];
          if (!pattern || !pattern.test(parm.Value)) {
            obj = {
              err: i18next.t("error:validation.invalidFormat", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        // Specific ID validations
        case "itemID":
          if (
            !parm.Value ||
            !/^ITM-\d{3}[A-Z]{2}-\d{3}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.itemIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "unitID":
          if (
            !parm.Value ||
            !/^UNT-[A-Z]{2}\d{3}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.unitIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "tagID":
          if (
            !parm.Value ||
            !/^TAG-\d{2}[A-Z]{3}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.tagIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "clientID":
          if (
            !parm.Value ||
            !/^CLT-\d{3}[A-Z]{2}-\d{2}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.clientIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "trafficID":
          const trafficRegex = /^TRF-(\d{4})(\d{2})(\d{2})-\d{3}$/;
          const trafficMatch = parm.Value
            ? parm.Value.match(trafficRegex)
            : null;
          if (!trafficMatch || parm.Value.length > 16) {
            obj = {
              err: i18next.t("error:validation.trafficIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          const year = parseInt(trafficMatch[1], 10);
          const month = parseInt(trafficMatch[2], 10);
          const day = parseInt(trafficMatch[3], 10);
          const date = new Date(year, month - 1, day);
          if (
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day
          ) {
            obj = {
              err: i18next.t("error:validation.trafficIDInvalidDate", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "userID":
          if (
            !parm.Value ||
            !/^USR-\d{3}[A-Z]{3}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.userIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "roleID":
          if (
            !parm.Value ||
            !/^ROL-\d{4}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.roleIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;

        case "warehouseID":
          if (
            !parm.Value ||
            !/^WH-\d{2}[A-Z]{2}-\d{2}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.warehouseIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;
        case "messageID":
          if (
            !parm.Value ||
            !/^MSG-[A-Z]{4}-[A-Z]{3}$/.test(parm.Value) ||
            parm.Value.length > 16
          ) {
            obj = {
              err: i18next.t("error:validation.messageIDInput", {
                field: i18next.t(parm.Name),
              }),
              errCode: 400,
            };
            return;
          }
          break;
      }
    }
  });

  return obj;
}

export function comparePermissionArrays(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i].HasPermission !== arr2[i].HasPermission) {
      return false;
    }
  }

  return true;
}

export function compareArrays(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((element) => arr2.includes(element));
}
export const compareDateTimes = (a, b) => {
  const parse = (str) => {
    let datePart;
    let timePart;
    if (str.includes(",")) [datePart, timePart] = str.split(", ");
    else {
      [datePart, timePart] = str.split(" ");
    }
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  return parse(a) - parse(b);
};

//returns error obj if false, and returns true if good
export function checkPasswordInput(
  password,
  MinLength = DEFAULT_PASS_MIN_LENGTH
) {
  let obj;

  if (!password || !/\S/.test(password)) {
    obj = {
      err: i18next.t("error:validation.passwordEmpty"),
      errCode: 400,
    };
  } else if (!/(?=.*[a-z])/.test(password)) {
    obj = {
      err: i18next.t("error:validation.passwordLowercase"),
      errCode: 400,
    };
  } else if (!/(?=.*[A-Z])/.test(password)) {
    obj = {
      err: i18next.t("error:validation.passwordUppercase"),
      errCode: 400,
    };
  } else if (MinLength !== undefined && password.length < MinLength) {
    obj = {
      err: i18next.t("error:validation.minLength", {
        field: "password",
        length: MinLength,
      }),
      errCode: 400,
    };
  } else if (!/(?=.*\d)/.test(password)) {
    obj = {
      err: i18next.t("error:validation.passwordDigit"),
      errCode: 400,
    };
  } else if (!/(?=.*[!@#$%^&*()_+[\]{}|;:'",.<>?/\\-])/.test(password)) {
    obj = {
      err: i18next.t("error:validation.passwordSpecial"),
      errCode: 400,
    };
  } else {
    obj = true;
  }
  return obj;
}
